// V2.1 Block Configuration (2026.1.1)
// This file defines blocks added in the 2026.1.1 patch release.

import { blocksV2 } from "../v2/blocksV2";
import SnapActionLogOut from "../v2/blocks/AppActions/LogOut";

export const blocksV2_1 = {
    ...blocksV2,
    "App Actions": {
        LogOut: {
            component: SnapActionLogOut,
            searchTags: ["log", "out", "logout", "actions", "user", "sign"]
        },
        ...blocksV2["App Actions"]
    }
};
